import { IDialogState } from 'interface/dialog/dialogInfo';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';

const initialState = {
  open: false,
  content: null,
  option: {},
  onClose: null,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
} as IDialogState;

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (state, action: { payload: IDialogState; type: string }) => {
      state.open = true;
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key as keyof IDialogState] = value;
      });
    },
    closeDialog: state => {
      state.open = false;
      state.content = null;
      state.option = {};
      state.onClose = null;
      state.disableBackdropClick = false;
      state.disableEscapeKeyDown = false;
      state.fullScreen = false;
    },
    fullScreen: (state, action: { payload: { fullScreen: boolean } }) => {
      const { fullScreen } = action.payload;
      state.fullScreen = fullScreen;
    },
  },
});

export const { openDialog, closeDialog, fullScreen } = dialogSlice.actions;
export default dialogSlice.reducer;

export const dialogSelector = (state: RootState): IDialogState => state.dialog;
